import React, { useEffect } from 'react';
import Input from './Input';
import { Wrapper, Label, CloseIcon } from './styled';
import { TagContainer, TagLabel, TagsWrapper } from '../../../TagsSection/styled';
import { useDispatch } from 'react-redux';

const Section = ({ tags, setTags, label, getOptions, options }) => {
  const dispatch = useDispatch();

  const onDelete = (id) => {
    const filteredTags = tags.filter((t) => t !== id);
    setTags(filteredTags);
  };

  useEffect(() => {
    dispatch(getOptions());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Wrapper>
      <Label children={ label } />
      <Input tagsAvailable={ options } tags={ tags } setTags={ setTags } />
      <TagsWrapper>
        { tags?.length > 0
          ? tags.map((t) =>
            <TagContainer key={ t.name ? `${t.name}-${t.id}` : t }>
              <TagLabel>{ t.name || t }</TagLabel>
               <CloseIcon onClick={ () => onDelete(t) } />
            </TagContainer>)
          : null
        }
      </TagsWrapper>
    </Wrapper>
  );
};

export default Section;
